import React, { Component } from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { observer } from "mobx-react";
import { Web3Store } from "../stores/web3Store";
import banner from "../images/market-banner.png";
import { Button, Input, Space, Tooltip } from "antd";
import { Swiper, SwiperSlide } from "swiper/react/swiper-react";
import {
    GetHomePageDataResponse,
    IHotBrand,
    IHotLicenseCollection,
    IHotLicenseNFTIP,
    ILicenseCollection,
    IMythServerResponse,
    IPRsp,
    IWellChosen
} from "../bean/ResponseBean"
import { Autoplay } from "swiper";
import "swiper/swiper.less";
import NFTIPList from "../components/nftIPList";
import "../styles/copyrightMarket.less";
import { MythServerResultCode } from "../constant/CommonConstant";
import logger from "../logger";
import { PageLoader } from "../components/pageLoader";
import { getRoutePath, MythRouteId } from "../router-config";
import MythImage from "../components/MythImage";
import { handleNFTName } from "../utils/commonUtils";

interface IProps {
    web3Store: Web3Store;
}

interface IStates {
    wellChosen: IWellChosen[],
    licenseCollections: ILicenseCollection[],
    hotLicenseCollections: IHotLicenseCollection[],
    hotNFTIPs: IHotLicenseNFTIP[],
    hotArtists: IHotBrand[],
    wellChosenIPList: IPRsp[],
    keywords: string,
    loading: boolean,
    searchIptShow: boolean,
}

interface IRecommendCollection {
    collectionId: number,
    name: string
}

type IMarketProps = IProps & RouteComponentProps;

@observer
class CopyrightMarket extends Component<IMarketProps, IStates> {
    private recommendSearch: IRecommendCollection[] = [{ name: "Azuki", collectionId: 4 }, {
        name: "Bored Ape Yacht Club",
        collectionId: 1
    }];

    constructor(props: IMarketProps, state: IStates) {
        super(props);
        this.state = {
            wellChosen: [],
            licenseCollections: [],
            hotLicenseCollections: [],
            hotNFTIPs: [],
            hotArtists: [],
            wellChosenIPList: [],
            keywords: "",
            loading: true,
            searchIptShow: false,
        }
    }

    componentDidMount(): void {
        this.getHomePageData();
        const scroll = document.getElementsByClassName("main-scrollbars")[0].firstChild;
        scroll && scroll.addEventListener('scroll', this.bindHandleScroll)
    }
    componentWillUnmount(): void {
        const scroll = document.getElementsByClassName("main-scrollbars")[0].firstChild;
        scroll && scroll.removeEventListener('scroll', this.bindHandleScroll)
    }
    bindHandleScroll = (event: any) => {
        const { searchIptShow } = this.state;
        const scroll = document.getElementsByClassName("main-scrollbars")[0].firstChild as HTMLElement;
        const input = document.getElementsByClassName("normal-search")[0] as HTMLElement;
        const inputHeight = input?.clientHeight;
        const inputTop = input?.offsetTop;
        const scrollTop = scroll?.scrollTop;
        if (!searchIptShow && scrollTop >= inputTop + inputHeight) {
            this.setState({ searchIptShow: true });
        }
        if (searchIptShow && scrollTop < inputTop + inputHeight) {
            this.setState({ searchIptShow: false });
        }
    }
    getHomePageData = async () => {
        const { web3Store } = this.props;
        try {
            if (web3Store.mythServerApi) {
                const result: IMythServerResponse<GetHomePageDataResponse> = await web3Store.mythServerApi?.getHomePageData();
                if (result.resultCode === MythServerResultCode.SUCCESS) {
                    const data = result.resultValue;
                    if (data) {
                        this.setState({
                            licenseCollections: data.licenseCollections,
                            wellChosen: data.wellChosenList,
                            hotLicenseCollections: data.hotLicenseCollections,
                            hotNFTIPs: data.hotLicensedNftIPS,
                            hotArtists: data.hotBrands,
                            wellChosenIPList: data.wellChosenIPList,
                            loading: false
                        });
                    }
                }
            }
        } catch (e) {
            logger.error(e);
        }
    };

    renderWellChosen = () => {
        const { wellChosen } = this.state;
        const firstItem = wellChosen[0];
        const list = wellChosen.slice(1, 5);
        return <div className="flex-row chosen-container">
            <div className="chosen-left">
                <div className="item-left" onClick={event => {
                    this.doFeaturedAction(firstItem);
                }}>
                    <img src={firstItem.image} alt="" />
                    <div className="item-name">{firstItem.name}</div>
                </div>
            </div>
            <div className="flex-row chosen-right">
                {list.map((item, i) => (
                    <div key={'c-' + i} className="item-right" onClick={event => {
                        this.doFeaturedAction(item);
                    }}>
                        <div>
                            <img src={item.image} alt="" />
                            <div className="item-name">{item.name}</div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    };

    private doFeaturedAction(item: IWellChosen) {
        const mythProtocol = "myth://";
        let index = item.url.indexOf(mythProtocol);
        if (index > -1) {
            const routeIdStr = item.url.substring(index + mythProtocol.length);
            if (routeIdStr) {
                const routeId = Number.parseFloat(routeIdStr);
                this.props.history.push({
                    pathname: getRoutePath(routeId)
                });
            }
        } else {
            window.open(item.url);
        }
    }

    renderHotItem = (image: string, text: string, number: number, textKey: string, key: string, onClickListener: (event: any) => void) => {
        return <div className="flex-row" key={key} onClick={onClickListener}>
            <MythImage src={image} alt="" className="item-img" />
            <div className="item-text">
                <p className="item-name">{text}</p>
                <p className="item-number">{textKey ? textKey + ":" : ""} {number}</p>
            </div>
        </div>
    };

    onClickPopularSeriesItem = (item: IHotLicenseCollection) => {
        this.props.history.push({
            pathname: getRoutePath(MythRouteId.IPListPage),
            state: { selectedCollectionId: item.id }
        });
    };

    onClickPopularIPItem = (item: IHotLicenseNFTIP) => {
        const url = getRoutePath(MythRouteId.OnePage) + "?ipId=" + item.id;
        this.props.history.push(url);
    };

    onClickPopularArtistItem = (item: IHotBrand) => {
        this.props.history.push({
            pathname: getRoutePath(MythRouteId.BrandInfo),
            state: { brandId: item.brandId }
        });
    };

    viewAll = () => {
        this.props.history.push({ pathname: getRoutePath(MythRouteId.IPListPage), state: { keywords: "" } });
    };

    enterInput = (e: any) => {
        const value = e.target.value;
        this.props.history.push({ pathname: getRoutePath(MythRouteId.IPListPage), state: { keywords: value } });
    };

    onClickRecommendSearch = (item: IRecommendCollection) => {
        this.props.history.push({
            pathname: getRoutePath(MythRouteId.IPListPage),
            state: { selectedCollectionId: item.collectionId }
        });
    };

    onClickLicenseNFT = (e: any) => {
        this.props.history.push({
            pathname: getRoutePath(MythRouteId.LicensePage),
        });
    };

    onClickLicenseWork = (e: any) => {
        window.open('https://forms.gle/6TZZX1um1vWUgvo16');
    };

    render() {
        const { searchIptShow, wellChosen, wellChosenIPList, hotArtists, hotLicenseCollections, hotNFTIPs, licenseCollections, loading } = this.state;
        return <div className="market-container main-container">
            {searchIptShow && <Input className="market-search sticky-search" onPressEnter={this.enterInput}
                prefix={<i className="iconfont icon-search"></i>}
                placeholder="Search by collection" />}
            <div className="market-banner text-center" style={{ backgroundImage: `url(${banner})` }}>
                <div className="market-title">Community-driven<br />NFT
                    <span className="dazzling-text"> Licensing <span className="dazzling-text"> Licensing </span></span>
                    market
                </div>
                {/* normal search input  */}
                <Input id="normalSearch" className="market-search normal-search" onPressEnter={this.enterInput}
                    prefix={<i className="iconfont icon-search"></i>}
                    placeholder="Search by collection" />
                <div className="top-search">
                    {this.recommendSearch.map((item: IRecommendCollection, i: number) => (
                        <span className="search-item" key={'search-' + i} onClick={event => {
                            this.onClickRecommendSearch(item);
                        }}>{item.name}</span>
                    ))}
                </div>
                <Space size={40}>
                    <span className="authorize-link" onClick={this.onClickLicenseNFT}>License my NFT <i
                        className="iconfont icon-24gf-forward"></i></span>
                    <span className="authorize-link" onClick={this.onClickLicenseWork}>License my work <i
                        className="iconfont icon-24gf-forward"></i></span>
                </Space>
                <Swiper
                    breakpoints={{
                        "1201": { slidesPerView: 13 },
                        "980": { slidesPerView: 10 },
                        "768": { slidesPerView: 8 },
                        "320": { slidesPerView: 5 },
                    }}
                    loop
                    autoplay={{
                        delay: 4000
                    }}
                    modules={[Autoplay]}
                    className="market-swiper"
                >
                    {licenseCollections.map((item: ILicenseCollection, index: number) => (
                        <SwiperSlide key={index} className="market-swiper-item">
                            <Tooltip placement="top" color="rgba(255,255,255,0.8)" overlayClassName="tool-content"
                                title={item.name}>
                                <img src={item.logo} alt="" className="swiper-img" />
                            </Tooltip>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
            {loading ? <PageLoader></PageLoader> :
                <div className="market-section">
                    <div className="list-title">Featured</div>
                    {!!wellChosen.length && this.renderWellChosen()}
                    <div className="flex-row hot-content space-between">
                        <div className="hot-flex-item">
                            <div className="list-title">Popular Collections</div>
                            <div className="flex-panel">
                                {hotLicenseCollections.map((item, i) => (
                                    this.renderHotItem(item.logo, item.name, item.licensed, "Entries", 'c-' + i, event => {
                                        this.onClickPopularSeriesItem(item);
                                    })
                                ))}
                            </div>
                        </div>
                        <div className="hot-flex-item">
                            <div className="list-title">Popular IPs</div>
                            <div className="flex-panel">
                                {hotNFTIPs.map((item, i) => (
                                    this.renderHotItem(item.image, handleNFTName(item.collectionName, item.tokenId), item.entries, "Entries", 'ip-' + i, event => {
                                        this.onClickPopularIPItem(item);
                                    }))
                                )}
                            </div>
                        </div>
                        <div className="hot-flex-item">
                            <div className="list-title">Popular Brands</div>
                            <div className="flex-panel">
                                {hotArtists.map((item, i) => (
                                    this.renderHotItem(item.logo, item.name, item.category, "", 'a-' + i, event => {
                                        this.onClickPopularArtistItem(item);
                                    })
                                ))}
                            </div>
                        </div>
                    </div>

                    <NFTIPList list={wellChosenIPList} className="chosenip-list" title="All IPs"
                        extra={<Button className="myth-button" onClick={this.viewAll}>View All</Button>} />
                </div>
            }
        </div>
    }
}

export default withRouter(CopyrightMarket);
